// Timed CPT codes that require start/end timestamps with code-specific rules.
// Start = appointment end + 2 min (add-ons start 31 min after their base code's end);
// codes that continue another code start from that code's end (see PREDECESSORS).
// End windows (minutes after start): 96372 = 2..4, base infusion = 31..59, add-on = 1..59,
// IV push = 5..16.

export const INJECTION_CODE = '96372';
export const BASE_INFUSION_CODES = ['96360', '96365'];
export const ADDON_TO_BASE = {'96361': '96360', '96366': '96365'};
// IV push codes: 96374 starts after the consultation like the injection, 96375 continues at
// 96374's end, 96376 resumes 30 min after the end of 96374, 96375 or the base infusion.
export const IV_PUSH_INITIAL_CODE = '96374';
export const IV_PUSH_CODES = ['96374', '96375', '96376'];
export const TIMED_CPT_CODES = ['96372', '96360', '96365', '96361', '96366', '96374', '96375', '96376'];

export const START_AFTER_APPT_END_MIN = 2;
export const ADDON_START_AFTER_BASE_END_MIN = 31;
// Gap between consecutive timed codes on the same visit (e.g. base infusion after an injection).
export const SEQUENTIAL_GAP_MIN = 2;
// 96372 can only last 2-4 min and is always recorded as 4 (fixed, read-only).
export const INJECTION_DURATION_MIN = 4;
// 96376 resumes 30 min after its predecessor's end; 96375 continues immediately.
export const IV_PUSH_SAME_DRUG_START_AFTER_END_MIN = 30;

// Codes whose start comes from another code's end; the latest end among them wins.
const PREDECESSORS = {
    '96375': ['96374'],
    '96376': ['96374', '96375', '96365']
};
const PREDECESSOR_GAP_MIN = {
    '96375': 0,
    '96376': IV_PUSH_SAME_DRUG_START_AFTER_END_MIN
};
export const predecessorsOf = (code) => PREDECESSORS[code] || [];
export const gapAfterPredecessorEnd = (code) => PREDECESSOR_GAP_MIN[code] || 0;

// Medication codes (Cpt.activityType === 5) carry no timestamp and are excluded from the division.
export const MEDICATION_ACTIVITY_TYPE = 5;
export const isMedication = (cpt) => !!cpt && cpt.activityType === MEDICATION_ACTIVITY_TYPE;

const INJECTION_WINDOW = {min: 2, max: 4};
const BASE_WINDOW = {min: 31, max: 59};
const ADDON_WINDOW = {min: 1, max: 59};
const IV_PUSH_WINDOW = {min: 5, max: 16};

export const isTimed = (code) => TIMED_CPT_CODES.includes(code);
export const isInjection = (code) => code === INJECTION_CODE;
export const isBaseInfusion = (code) => BASE_INFUSION_CODES.includes(code);
export const isAddon = (code) => Object.prototype.hasOwnProperty.call(ADDON_TO_BASE, code);
export const isIvPush = (code) => IV_PUSH_CODES.includes(code);

export const windowFor = (code) => {
    if (code === INJECTION_CODE) return INJECTION_WINDOW;
    if (isBaseInfusion(code)) return BASE_WINDOW;
    if (isAddon(code)) return ADDON_WINDOW;
    if (isIvPush(code)) return IV_PUSH_WINDOW;
    return null;
};
